import { getLocationWithoutPrivateParams, removeQueryStringParams } from './base/utils'
import { PERSONAL_IDENTIFIABLE_INFORMATION } from './utils/private-data-params'
import { isLoggedIn } from './helpers/user'

removeQueryStringParams(PERSONAL_IDENTIFIABLE_INFORMATION)
const currentLocationWithoutPrivateParams = getLocationWithoutPrivateParams()

// Use different GA4 IDs based on the domain
const domain = window.location.hostname
const ga4PropertyId = /^(.+\.)?sketch\.com$/.test(domain) ? 'G-S7QXTWBHW7' : 'G-RFCQ22DDD9'

const dimensionValue = !isLoggedIn() ? 'Anonymous' : 'Signed in'

// GA4
gtag('config', ga4PropertyId, {
  send_page_view: false,
  // Anonymize IP for user privacy
  anonymize_ip: true,
  // Use Navigator.sendBeacon if supported
  transport_type: 'beacon',
  // Cross-site config
  linker: { domains: ['sketch.com', 'sketchapp.com', 'fastspring.com', 'sites.fastspring.com'] },
})

// Set the user-scoped custom dimension to Anonymous or Signed in based on the user’s authentication status
gtag('set', 'user_properties', {
  authentication: dimensionValue,
})

// Initial hit
gtag('event', 'page_view', {
  send_to: ga4PropertyId,
  page_location: currentLocationWithoutPrivateParams,
})
